import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import styled from 'foundations-theming/utils';
import { filterProps } from '../../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../../hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledTBody = styled.tbody.withConfig({
  displayName: "TableBody__StyledTBody",
  componentId: "cmal66-0"
})(({
  $cssStyles
}) => {
  return Object.assign({}, $cssStyles);
});
export const TableBody = _ref => {
  let {
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    callbackProps,
    tokenProps,
    restProps
  } = filterProps(props);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledTBody, Object.assign({}, domProps, callbackProps, restProps, {
    $cssStyles: cssStyles,
    children: children
  }));
};